<template>
  <v-footer dark padless>
    <v-card flat tile class="secondary white--text text-center">
      <v-card-text>
        <v-btn
          v-for="(icon, i) in icons"
          :key="i"
          class="mx-4 white--text"
          :href="icon.link"
          target="_blank"
          icon
        >
          <v-icon size="24px">{{ icon.text }}</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class="font-weight-light white--text pt-0">
        Connect with us via any of our social media handle above
      </v-card-text>
      <v-divider></v-divider>

      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} —
        <strong>Soft-Tech Design Systems | All rights reserved</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}
</style>

<script>
export default {
  data: () => ({
    icons: [
      {
        text: "mdi-whatsapp",
        link: "https://wa.me/message/WTBPYCV2CVOXA1",
      },
      {
        text: "mdi-twitter",
        link: "https://twitter.com/softech_designs",
      },
      {
        text: "mdi-linkedin",
        link: "",
      },
    ],
  }),
};
</script>
